<template>
    <v-dialog
        v-model="show"
        max-width="320"
    >
        <v-card>
            <v-toolbar
                color="primary"
                dark
                flat
            >
                <v-toolbar-title>
                    Partial Matching
                </v-toolbar-title>
            </v-toolbar>

            <v-card-text class="pt-5">
                <p>
                    This offer allows you to send any amount as long as it is less than {{ order.matcher_amount_formatted }}.
                </p>
            </v-card-text>

            <v-divider />

            <v-card-actions class="justify-center">
                <v-btn
                    depressed
                    @click="show = false"
                >
                    I understand
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    export default {
        props: {
            value: {
                type: Boolean,
                default: false,
            },
            order: {
                type: Object,
                required: true,
            },
        },
        computed: {
            show: {
                get() {
                    return this.value;
                },
                set(val) {
                    this.$emit('input', val);
                },
            },
            currency() {
                return this.order && this.order.matcher_currency;
            },
        },
    };
</script>
